import {
    Label,
    Text,
    DisplayField,
    Layout,
    LayoutContainer,
} from "@relode/core";
import { Day, TimeZone } from "@relode/core/domain";
import * as React from "react";

import { CandidateAvailability, CandidateAdditionalInfo } from "../../types";

interface InterviewAvailabilityProps {
    availability?: CandidateAvailability;
    additionalInfo: CandidateAdditionalInfo;
}

export const InterviewAvailability = (props: InterviewAvailabilityProps) => {
    const { availability, additionalInfo } = props;

    if (!availability) return null;

    const timeZone = TimeZone.fromId(availability?.timeZoneId);

    const bestTimesToReach = Day.fromTags(
        availability.contactPreferences
    ).reduce((acc: string[], theDay: Day): string[] => {
        acc.push(theDay.toString());
        return acc;
    }, []);

    return (
        <LayoutContainer>
            <Layout mode="100">
                <Text variant="h2">availability</Text>
                <DisplayField
                    label="available to start"
                    value={availability.noticeAvailability?.tagName}
                />
                <DisplayField
                    label="interview availability"
                    component={
                        <div data-cy="bestTimesToReachDiv">
                            {bestTimesToReach.length > 0 ? (
                                bestTimesToReach.map(item => (
                                    <Text
                                        variant="body1"
                                        key={`${item}BestTimesToReach`}
                                    >
                                        {item}
                                    </Text>
                                ))
                            ) : (
                                <Text variant="body1">not specified</Text>
                            )}
                            {/* HACK: use of label here feels like a hack to get some small text that has the same styles as a field label */}
                            <Label
                                label={`timezone - all times in  ${timeZone.description}`}
                            >
                                <span />
                            </Label>
                        </div>
                    }
                />
                <DisplayField
                    label="interview availability notes"
                    value={availability.interviewAvailabilityNote}
                    preserveTextFormat
                />
                <DisplayField
                    label="Is this candidate interviewing elsewhere?"
                    value={
                        additionalInfo.isInterviewingElsewhere
                            ? "Yes"
                            : "No"
                    }
                />

                <DisplayField
                    label="where are they in the interview process?"
                    value={additionalInfo.interviewingElsewhereNote}
                    hidden={!additionalInfo.isInterviewingElsewhere}
                    preserveTextFormat
                    data-cy="interviewingElsewhereNote"
                />
            </Layout>
        </LayoutContainer>
    );
};
